const API_URL = 'https://api.aiisc.cse.sc.edu/';
//const API_URL = "http://129.252.131.33:5000/"
//const API_URL = 'http://localhost:3000/';
export default  API_URL ;
